import React, { useMemo } from 'react';
import { Box, FormControl } from '@mui/material';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { FormField } from '../utils/formFieldTypes';
import { renderFieldLabel, renderError, renderHelpText } from '../utils';

interface PhoneInputComponentProps {
    field: FormField;
    value: string;
    onChange: (value: string, data: any) => void;
    disabled?: boolean;
    errorMessage?: string;
    hideLabel?: boolean;
    showDynamicHint?: boolean;
    containerStyle?: React.CSSProperties;
}

const PhoneInputComponent: React.FC<PhoneInputComponentProps> = ({
    field,
    value,
    onChange,
    disabled = false,
    errorMessage = '',
    hideLabel = false,
    showDynamicHint = true,
    containerStyle = {},
}) => {
    // Memoize phone input styling to prevent unnecessary re-renders
    const phoneInputStyle = useMemo(
        () => ({
            borderColor: errorMessage ? '#d32f2f' : '#a3a3a3',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderRadius: '50px',
            height: '48px',
            width: '100%',
            outline: 'none',
            boxShadow: 'none',
            fontSize: '16px',
            background: 'transparent',
            color: 'white !important',
            fontFamily: 'inherit',
        }),
        [errorMessage]
    );

    return (
        <FormControl
            fullWidth
            margin='normal'
            sx={{
                ...containerStyle,
            }}
        >
            {renderFieldLabel(field, hideLabel)}

            {/* Phone Input Component */}
            <Box position='relative'>
                <PhoneInput
                    country={field.country || 'us'}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                    inputStyle={phoneInputStyle}
                    containerClass='phone-input-custom text-secondary'
                    enableAreaCodes={false}
                    preferredCountries={['us', 'gb', 'ca', 'au', 'in']}
                    countryCodeEditable={true}
                    disableDropdown={false}
                    searchPlaceholder='Search country...'
                />
            </Box>

            {/* Error message display */}
            {renderError(errorMessage)}

            {/* Additional help text (optional) */}
            {renderHelpText(field)}
        </FormControl>
    );
};

export default PhoneInputComponent;
